<template>
  <div class="flex items-center gap-x-2 overflow-x-auto scrollbar-hidden-for-touch-devices">
    <slot />
  </div>
</template>
